import React from 'react';
import { useNav } from '../../hx/useNav';
import { useTranslation } from '../../hx/useTranslation';
import * as FxLog from '../../fx/FxLog';
import { clearStore, StoreSettEmail } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import GxList from '../../gx/GxList';
import { useWindowSize } from '../../hx/useWindowSize';


const MxSettCommEmailList = (props) => {
  const [{ trans }] = useTranslation();
  const size = useWindowSize();
  const [{ navTo }] = useNav();

  const [storeSettEmail, setStoreSettEmail] = useSessionStorage('StoreSettEmail', StoreSettEmail);
  const r_list = React.useRef(null);

  React.useEffect(() => {
    clearStore('StoreSettEmail', storeSettEmail);
    formLoad();
    // eslint-disable-next-line
  }, []);

  const formLoad = async () => {
  }

  const openForm = async (op, row) => {
    if (row === null) {
      storeSettEmail.itEmail = null;
    } else {
      storeSettEmail.itEmail = row.original.itEmail;
    }
    setStoreSettEmail(storeSettEmail);
    navTo("sett-comm-email-form");
  }

  const getTableColumns = () => {
    let cols = [];
    try{
      let id = -1;
      cols.push({ id: id++, Header: "ID", accessor: "itEmail", show: false });
      if (size.isLarge) { // PANTALLA GRANDE
        cols.push({ id: id++, Header: trans('field.account'), accessor: "txName", highlight: true, width: '45%' });
        cols.push({ id: id++, Header: trans('field.email'), accessor: "txUser", width: '45%' });
        cols.push({ id: id++, Header: trans('field.for_comm'), accessor: row => (row["boForComm"]==='1' ? trans('field.yes') : trans('field.no')), width: '10%' });

      } else { // PANTALLA PEQUEÑA
        cols.push({ id: id++, Header: trans('field.account'), accessor: "txName", highlight: true, width: '100%' });
      
      }
      cols.push({ id: "B", Header: trans('field.default_0'), accessor: row => Boolean(row["boDefault"]==='1'), show: false });

    } catch(error) {
      FxLog.errorx('MxSettCommEmailList.getTableColumns', error)
    }
    return cols;
  }

  return (
    <div>
      <GxList
        moduleName={`${trans('field.comms')}: ${trans('field.email')}`}
        xref={r_list}
        tooltip={`${trans('field.name')}`}
        fullscreen
        url="sett/email"
        onOpenForm={openForm}
        refColors={[
          'table_cell_color_blue|' + trans('field.default_0'),
        ]}
        columns={getTableColumns()}
      />
    </div>
  );

}

export default MxSettCommEmailList;
